export const reportStatusOptions = [
  { label: '全部状态', value: '' },
  { label: '无监管记录', value: 'NONE' },
  { label: '学习中', value: 'STARTED' },
  { label: '待上报', value: 'READY_REPORT' },
  { label: '上报中', value: 'REPORTING' },
  { label: '已上报', value: 'REPORTED' },
  { label: '上报失败', value: 'FAILED' },
  { label: '已取消', value: 'CANCELLED' }
]

const statusLabels = reportStatusOptions.reduce((result, item) => {
  if (item.value) result[item.value] = item.label
  return result
}, {})

export function formatHours (seconds) {
  return (Number(seconds || 0) / 3600).toFixed(2)
}

export function reportStatusLabel (status) {
  return statusLabels[status] || '无监管记录'
}

export function reportStatusType (status) {
  if (status === 'REPORTED') return 'success'
  if (status === 'FAILED') return 'danger'
  if (status === 'READY_REPORT') return 'warning'
  if (status === 'REPORTING' || status === 'STARTED') return 'primary'
  return 'info'
}
